"use client";

const BlogSkeleton = () => {
  return (
    <div className="min-h-screen bg-[#212121]">
      {/* Main Content Container - matching blog template */}
      <div className="container mx-auto px-4 pt-40 pb-24 max-w-6xl">
        {/* Breadcrumb Skeleton */}
        <nav className="mb-8">
          <div className="flex items-center space-x-2 text-sm">
            <div className="h-4 w-12 bg-[#2a2a2a] rounded animate-pulse" />
            <div className="w-1 h-4 bg-[#2a2a2a] rounded animate-pulse" />
            <div className="h-4 w-16 bg-[#2a2a2a] rounded animate-pulse" />
            <div className="w-1 h-4 bg-[#2a2a2a] rounded animate-pulse" />
            <div className="h-4 w-32 bg-[#2a2a2a] rounded animate-pulse" />
          </div>
        </nav>

        {/* Tags Skeleton */}
        <div className="flex flex-wrap gap-2 mb-8">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-6 w-16 bg-[#2a2a2a] border border-white/10 rounded-full animate-pulse"
            />
          ))}
        </div>

        {/* Title Skeleton */}
        <div className="space-y-3 mb-6">
          <div className="h-10 bg-[#2a2a2a] rounded animate-pulse" />
          <div className="h-10 w-4/5 bg-[#2a2a2a] rounded animate-pulse" />
        </div>

        {/* Excerpt Skeleton */}
        <div className="space-y-2 mb-8">
          <div className="h-5 bg-[#2a2a2a] rounded animate-pulse" />
          <div className="h-5 w-5/6 bg-[#2a2a2a] rounded animate-pulse" />
        </div>

        {/* Author and meta info after excerpt */}
        <div className="flex justify-between items-center mb-8 pt-4 border-t border-white/10">
          <div className="flex items-center space-x-4">
            <div className="h-4 w-20 bg-[#2a2a2a] rounded animate-pulse" />
            <div className="flex items-center">
              <div className="w-4 h-4 bg-[#2a2a2a] rounded mr-1 animate-pulse" />
              <div className="h-4 w-20 bg-[#2a2a2a] rounded animate-pulse" />
            </div>
            <div className="flex items-center">
              <div className="w-4 h-4 bg-[#2a2a2a] rounded mr-1 animate-pulse" />
              <div className="h-4 w-16 bg-[#2a2a2a] rounded animate-pulse" />
            </div>
          </div>

          {/* Share buttons skeleton */}
          <div className="flex items-center space-x-2">
            <div className="h-4 w-12 bg-[#2a2a2a] rounded animate-pulse mr-3" />
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="w-9 h-9 rounded-full bg-white/5 animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Featured Image Skeleton */}
        <div className="mb-12">
          <div className="relative">
            <div className="w-full h-80 lg:h-[500px] bg-[#2a2a2a] rounded-lg animate-pulse" />
          </div>
        </div>

        {/* Content Skeleton */}
        <div
          className="section-block-padding blog-posts blog-content"
          style={{ minHeight: "400px" }}
        >
          <div className="space-y-6 mb-12">
            {/* Paragraph skeletons */}
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="space-y-3">
                <div className="h-4 bg-[#2a2a2a] rounded animate-pulse" />
                <div className="h-4 w-11/12 bg-[#2a2a2a] rounded animate-pulse" />
                <div className="h-4 w-5/6 bg-[#2a2a2a] rounded animate-pulse" />
                <div className="h-4 w-4/5 bg-[#2a2a2a] rounded animate-pulse" />
              </div>
            ))}

            {/* Heading skeleton */}
            <div className="h-8 w-3/4 bg-[#2a2a2a] rounded animate-pulse my-8" />

            {/* More paragraphs */}
            {[1, 2, 3].map((i) => (
              <div key={i + 6} className="space-y-3">
                <div className="h-4 bg-[#2a2a2a] rounded animate-pulse" />
                <div className="h-4 w-10/12 bg-[#2a2a2a] rounded animate-pulse" />
                <div className="h-4 w-3/4 bg-[#2a2a2a] rounded animate-pulse" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Recommended for you Skeleton */}
      <section className="py-16 bg-[#212121]">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center mb-12">
            <div className="h-8 w-48 bg-[#2a2a2a] rounded mx-auto animate-pulse" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <article key={i} className="group cursor-pointer">
                {/* Image */}
                <div className="relative overflow-hidden rounded-lg mb-4">
                  <div className="w-full h-[240px] bg-[#2a2a2a] animate-pulse" />
                </div>

                {/* Title */}
                <div className="space-y-2">
                  <div className="h-5 bg-[#2a2a2a] rounded animate-pulse" />
                  <div className="h-5 w-3/4 bg-[#2a2a2a] rounded animate-pulse" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogSkeleton;
